interface Props {
  stroke?: string;
  className: string;
}

const Billing = ({ className, stroke = '#1a1818' }: Props) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M17.2245 6.63428C18.3399 8.02826 19 9.75657 19 11.6283C19 16.2519 14.9708 19.9998 10.0002 19.9998C5.02966 19.9998 1 16.2519 1 11.6283C1 9.77104 1.65015 8.05559 2.75002 6.66683"
      stroke={stroke}
      strokeWidth="1.12128"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.72827 16.6046V2.80948C2.72827 1.81453 3.6035 1 4.67398 1H15.327C16.3971 1 17.2723 1.81453 17.2723 2.80948V16.6046"
      stroke={stroke}
      strokeWidth="1.12128"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7265 5.17134C10.768 5.21952 10.8142 5.23398 10.8613 5.23398C10.9542 5.23398 11.0268 5.16644 11.0268 5.07967C11.0268 5.04596 11.0168 5.01703 10.9961 4.98809C10.7935 4.71324 10.4466 4.52518 10.0111 4.49625V4.12976C10.0111 4.06222 9.94849 4.00439 9.87591 4.00439C9.80333 4.00439 9.74156 4.06226 9.74156 4.12976V4.49625C9.08277 4.54443 8.78253 4.9013 8.78253 5.31599C8.78253 6.45881 10.7416 6.03448 10.7416 6.9362C10.7416 7.36054 10.4207 7.57271 9.85043 7.57271C9.39424 7.57271 9.09357 7.36536 8.92768 7.11462C8.89658 7.06644 8.84474 7.0375 8.78253 7.0375C8.68879 7.0375 8.61621 7.10505 8.61621 7.19181C8.61621 7.22075 8.62186 7.24 8.64256 7.27861C8.80845 7.57275 9.20243 7.83797 9.74156 7.8669V8.22856C9.74156 8.29611 9.80334 8.35393 9.87591 8.35393C9.94849 8.35393 10.0111 8.29606 10.0111 8.22856V7.86691C10.7053 7.82351 11.0946 7.50042 11.0946 6.93624C11.0946 5.77413 9.13461 6.1165 9.13461 5.31603C9.13461 5.04117 9.3424 4.79043 9.88671 4.79043C10.3217 4.79043 10.571 4.99296 10.7265 5.17137L10.7265 5.17134Z"
      stroke={stroke}
      strokeWidth="0.616704"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.10815 10.9287H14.2081"
      stroke={stroke}
      strokeWidth="1.12128"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.10815 12.7876H14.2081"
      stroke={stroke}
      strokeWidth="1.12128"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.10815 14.646H14.2081"
      stroke={stroke}
      strokeWidth="1.12128"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Billing;
